// initializeEditedTrip — pure normalization of the incoming `trip` into the
// modal's initial `editedTrip` working copy.
//
// Extracted verbatim from `EditTripModal.js` (the `useState` initializer
// `{ ...trip, meetings: trip.meetings || [] }`) as part of the
// behavior-preserving refactor (issue #240). It shallow-copies `trip` and
// guarantees a `meetings` array, defaulting a missing/falsy `meetings` to `[]`.
//
// Totality preserved exactly: the source did NOT guard `trip` itself — it read
// `trip.meetings` directly — so a `null`/`undefined` `trip` throws here just as
// it would have at the original call site. The `meetings || []` fallback is
// reproduced verbatim. The state seeding (`useState`) stays in the hook/container.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Builds the initial edited-trip working copy from the incoming trip.
 *
 * @param {Object} trip - The trip passed to the modal.
 * @returns {Object} A shallow copy of `trip` with a guaranteed `meetings` array.
 */
export function initializeEditedTrip(trip) {
  return {
    ...trip,
    meetings: trip.meetings || []
  };
}

export default initializeEditedTrip;
